module.exports = __webpack_public_path__ + "static/media/icon-email.b02b43ac.png";